import type { SVGProps } from 'react';

export const WarningIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      {...props}
    >
      <path
        d="M16.1986 17.998H2.99975C1.34569 17.998 0 16.6524 0 14.9983C0 14.485 0.132064 13.9783 0.382018 13.5326L6.97985 1.53648C6.98101 1.53438 6.98217 1.53232 6.98334 1.53022C8.12928 -0.507095 11.0686 -0.507845 12.2151 1.53022C12.2162 1.53228 12.2174 1.53438 12.2186 1.53648L18.8164 13.5326C19.0663 13.9782 19.1984 14.485 19.1984 14.9983C19.1984 16.6524 17.8527 17.998 16.1986 17.998ZM8.2922 2.26272L1.69463 14.2583C1.69347 14.2604 1.69231 14.2625 1.69115 14.2646C1.56602 14.487 1.49987 14.7407 1.49987 14.9983C1.49987 15.8253 2.17272 16.4982 2.99975 16.4982H16.1986C17.0257 16.4982 17.6985 15.8253 17.6985 14.9983C17.6985 14.7407 17.6324 14.487 17.5072 14.2646C17.5061 14.2625 17.5049 14.2604 17.5038 14.2583L10.9063 2.26291C10.3322 1.2472 8.86695 1.24603 8.2922 2.26272Z"
        fill="#A3ACBD"
      />
      <path
        d="M9.59906 11.2485C9.18487 11.2485 8.84912 10.9128 8.84912 10.4986V5.99896C8.84912 5.58477 9.18487 5.24902 9.59906 5.24902C10.0132 5.24902 10.349 5.58477 10.349 5.99896V10.4986C10.349 10.9128 10.0132 11.2485 9.59906 11.2485Z"
        fill="#A3ACBD"
      />
      <path
        d="M9.59906 14.2484C10.0132 14.2484 10.349 13.9127 10.349 13.4985C10.349 13.0843 10.0132 12.7485 9.59906 12.7485C9.18488 12.7485 8.84912 13.0843 8.84912 13.4985C8.84912 13.9127 9.18488 14.2484 9.59906 14.2484Z"
        fill="#A3ACBD"
      />
    </svg>
  );
};